export default __webpack_public_path__ + "825cf21ea90e0a06440e2a5a677421df.mp3";